import { Avatar } from "../../pngs";
import * as React from "react";
import { ROUTES } from "../consts/routes.consts";
import { useNavigate } from "react-router-dom";
import { useGetCuratorsListQuery } from "../apis/curatorsApi";
import { useGetCalendarValueQuery } from "../apis/topCuratorsApi";
import dayjs from "dayjs";
import { Home } from "../../pages/home/home";

interface homeComponentProp {
  props: any;
}

const TopCuratorHome: React.FC<homeComponentProp> = ({ props }) => {
  const [date, setDate] = React.useState<any>(dayjs());
  const currentDate = dayjs();

  const getLastWeekDates = (date: any) => {
    const currentDate = dayjs(date);
    const currentDay = currentDate.day();
    const lastSunday =
      currentDay === 0
        ? currentDate.subtract(7, "day")
        : currentDate.subtract(currentDay, "day");

    const lastMonday = lastSunday.subtract(6, "day");
    const formattedLastMonday = lastMonday.format("D MMM YYYY");
    const formattedLastSunday = lastSunday.format("D MMM YYYY");

    return `${formattedLastMonday} - ${formattedLastSunday}`;
  };

  const handleDateChange = (newDate: any) => {
    if (newDate && newDate.isValid()) {
      setDate(newDate);
    }
  };

  const handlePreviousDay = () => {
    const newDate = date.subtract(1, "day");
    handleDateChange(newDate);
  };

  const handleNextDay = () => {
    const newDate = date.add(1, "day");
    if (newDate.isBefore(currentDate) || newDate.isSame(currentDate, "day")) {
      handleDateChange(newDate);
    }
  };

  const formattedDate = date.format("DD-MM-YYYY");

  const isNextDayDisabled = date.isSame(currentDate, "day");

  const { data } = useGetCalendarValueQuery<any>({ date: formattedDate });
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const navigate = useNavigate();
  const playlist = "https://open.spotify.com/playlist";
  const [searchInput, setSearchInput] = React.useState<string>("");
  const parts = searchInput.split("/");
  const lastPart = parts[parts.length - 1];
  const [playlistId, queryString] = lastPart.split("?");
  const { refetch } = useGetCuratorsListQuery<any>(
    { playlistId: playlistId },
    {
      skip: !searchInput.includes(playlist),
    }
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const token = localStorage.getItem("token");
  const handleConnect = async () => {
    //  window.location.href = `http://localhost:9090/api/auth/login?page=DASHBOARD`;
    window.location.href = `https://api.pitchplaylists.com/api/auth/login?page=DASHBOARD`;
  };
  const userId = localStorage.getItem("userId");
  const isLoggedIn = token && userId;
  React.useEffect(() => {
    if (searchInput.includes(playlist)) {
      if (isLoggedIn) {
        refetch({ playlistId: playlistId }).then((response: { data: any }) => {
          navigate(ROUTES.CONFIRM_PLAYLIST, {
            state: { playlistData: response.data },
          });
        });
      } else {
        handleConnect();
      }
    } else {
      setTimeout(() => {
        setSearchInput("");
      }, 1000);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch, searchInput]);
  const open = Boolean(anchorEl);
  const sortedData = data && [...data].sort((a, b) => a.position - b.position);

  const getTimeUntilNextMonday = () => {
    const now: any = new Date();
    const nextMonday: any = new Date(now);
    nextMonday.setDate(now.getDate() + ((1 + 7 - now.getDay()) % 7 || 7));
    nextMonday.setHours(0, 0, 0, 0);
    return nextMonday - now;
  };

  const getTimeComponents = (milliseconds: number) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return { days, hours, minutes, seconds };
  };

  const [timeRemaining, setTimeRemaining] = React.useState(
    getTimeUntilNextMonday()
  );
  const [timeComponents, setTimeComponents] = React.useState(
    getTimeComponents(timeRemaining)
  );

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining((prevTimeRemaining) => {
        if (prevTimeRemaining <= 1000) {
          // updateTop20List();
          return 7 * 24 * 3600 * 1000;
        }
        return prevTimeRemaining - 1000;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => {
    setTimeComponents(getTimeComponents(timeRemaining));
  }, [timeRemaining]);
  const lastWeekDates = getLastWeekDates(date);

  return (
    <>
      <section className="pt-20 pb-16 md:pt-36 md:pb-24">
        <div className="container">
          <div className="update-curator-content flex  flex-col xl:flex-row gap-4 items-center">
            <div className="content-box  xl:w-[400px] xl:min-w-[400px] w-[100%]">
              <p
                className="content-box-text text-dark-gray md:text-base text-[12px] mb-4"
                dangerouslySetInnerHTML={{
                  __html: props?.sub_heading_1,
                }}
              >
              </p>
              <h2 className="content-box-heading md:!text-[50px] !text-[28px] font-[700]">
                {props?.heading.split(" ").slice(0, 3).join(" ")}{" "}
                <span className="gradient-text">
                  {props?.heading.split(" ").slice(3).join(" ")}
                </span>
              </h2>
              <p className="content-box-text text-light-gray md:text-xl text-[14px] mb-10 mt-3 md:mt-8">
                {props?.sub_heading_2}
              </p>
              <div className="flex sm:justify-start justify-center">
                <button
                  className="button button--secondary button--with-icon footer-button"
                  onClick={handleConnect}
                >
                  <img
                    src="/image/Spoty-logo.webp"
                    alt="Spotify Logo"
                    title="Spotify Logo"
                    width="30"
                    height="30"
                    loading="lazy"
                  />
                  Connect with Spotify
                </button>
              </div>
            </div>
            <div className="content-box-slider grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-start gap-4 xl:mt-[0] mt-[64px]">
              {sortedData && sortedData.length > 0 ? (
                sortedData
                  .slice(0, 3)
                  .map((value: any, index: any) => {
                    const responseRateString =
                    value?.responseRate?.$numberDecimal ?? "0";
                    const responseRateDecimal = parseFloat(responseRateString);
                    const responseRatePercentage = (responseRateDecimal * 100).toFixed(2);
                    const rawEngagementScore = value?.engagementScore?.engagementScore ?? 0;
                    const engagementScore = rawEngagementScore.toFixed(2); 
                    return { ...value, index, responseRatePercentage,engagementScore };
                  })
                  .sort((a: { index: number }, b: { index: number }) =>
                    a.index === 1 ? -1 : b.index === 1 ? 1 : a.index - b.index
                  )
                  .map(
                    (item: {
                      index: React.Key | null | undefined;
                      userId: {
                        profileUrl: string | undefined;
                        image: { url: any }[];
                        name:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<
                              any,
                              string | React.JSXElementConstructor<any>
                            >
                          | Iterable<React.ReactNode>
                          | React.ReactPortal
                          | null
                          | undefined;
                      };
                      position:
                        | string
                        | number
                        | boolean
                        | React.ReactElement<
                            any,
                            string | React.JSXElementConstructor<any>
                          >
                        | Iterable<React.ReactNode>
                        | React.ReactPortal
                        | null
                        | undefined;
                      weekInTopChart:
                        | string
                        | number
                        | boolean
                        | React.ReactElement<
                            any,
                            string | React.JSXElementConstructor<any>
                          >
                        | Iterable<React.ReactNode>
                        | React.ReactPortal
                        | null
                        | undefined;
                      responseRatePercentage:
                        | string
                        | number
                        | boolean
                        | React.ReactElement<
                            any,
                            string | React.JSXElementConstructor<any>
                          >
                        | Iterable<React.ReactNode>
                        | React.ReactPortal
                        | null
                        | undefined;
                        engagementScore:
                        | string
                        | number
                        | boolean
                        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                        | Iterable<React.ReactNode>
                        | React.ReactPortal
                        | null
                        | undefined;
                    }) => (
                      <div
                        key={item.index}
                        className={`${
                          item.index === 0
                            ? "card-shadow relative flex flex-col overflow-hidden shadow-sm rounded-[20px]"
                            : "card-shadow relative flex flex-col overflow-hidden shadow-sm rounded-[20px] xl:mt-[104px] mt-[0]"
                        } ${item.position == 1 ? "max-lg:-order-1" : ""}`}
                      >
                        <div className="relative flex items-center">
                          <a href="https://open.spotify.com/" rel="noopener noreferrer"  target="_blank">
                            <img
                              src="/image/card-frame.webp"
                              alt="Img card frame"
                              title="Img card frame"
                              width="352"
                              height="58"
                              loading="lazy"
                            />
                          </a>
                        </div>
                        <div className="2xl:p-[24px] p-[25px] 2xl:pt-[30px]">
                          <div className="mb-2 flex items-center justify-between">
                            <div className="text-slate-800 text-xl font-semibold">
                              {item.userId?.image[0]?.url ? (
                                <a
                                  href={item.userId.profileUrl}
                                  target="_blank"
                                >
                                  <img
                                    src={item.userId.image[0].url}
                                    alt="Spotify User Profile"
                                    title="Spotify User Profile Image"
                                    style={{
                                      objectFit: "cover",
                                      border: item.userId?.image[1]?.url
                                        ? "none"
                                        : "2px solid #FFFFFF",
                                      aspectRatio: "1 / 1",
                                    }}
                                    width={100}
                                    height={100}
                                    loading="lazy"
                                  />
                                </a>
                              ) : (
                                <div className="bg-[#878da1] flex items-center justify-center w-[100px] h-[100px]">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="100"
                                    height="100"
                                    viewBox="0 0 40 40"
                                    fill="none"
                                  >
                                    <rect
                                      width="40"
                                      height="40"
                                      fill="#878DA1"
                                    />
                                    <mask
                                      id="mask0_71_584"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="40"
                                      height="40"
                                    >
                                      <rect
                                        width="40"
                                        height="40"
                                        fill="white"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_71_584)">
                                      <path
                                        d="M30 24C30 22.3431 28.6569 21 27 21H13C11.3431 21 10 22.3431 10 24V25C10 28.9429 13.719 33 20 33C26.281 33 30 28.9429 30 25V24ZM25.5 13.5C25.5 10.4624 23.0376 8 20 8C16.9624 8 14.5 10.4624 14.5 13.5C14.5 16.5376 16.9624 19 20 19C23.0376 19 25.5 16.5376 25.5 13.5Z"
                                        fill="#111114"
                                      />
                                    </g>
                                  </svg>
                                </div>
                              )}
                            </div>
                            <p className="text-[120px] font-bold  text-gradient-2 leading-none ">
                              {item.position}
                            </p>
                          </div>
                          <div className="card-text-body mt-6">
                            <h2 className="text-[24px] leading-[130%] text-[#fff] mb-[40px] ">
                              {item.userId ? (
                                <a
                                  href={item.userId.profileUrl}
                                  target="_blank"
                                  className="hover:underline"
                                >
                                  {item.userId.name}
                                </a>
                              ) : (
                                <span className="text-[24px] leading-[130%] text-[#fff] mb-[40px]  italic">
                                  Curator Not Found
                                </span>
                              )}
                            </h2>
                            <p className="flex items-center justify-between">
                              <span className="text-[#4B4F55]">
                                Weeks in Top-chart:
                              </span>
                              <span className="text-[#58F2A9]">
                                {item.weekInTopChart}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    )
                  )
              ) : (
                <p className="content-box-text text-white font-bold md:text-2xl text-xl mb-10 mt-8 col-span-3">
                  The top 20 will be displayed once the first 20 curators join
                  our platform!
                </p>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TopCuratorHome;
